import React, { useEffect, useState } from "react";
import "./poll-result.css"; // Updated styles for positioning
import { fetchPollCount } from "../../../services/event/poll-result-show";

interface PollCountPopUPProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  currentSlide?: { pollId?: string };
  className?: string;
}

const PollCountPopUP: React.FC<PollCountPopUPProps> = ({
  isModalOpen,
  toggleModal,
  currentSlide,
}) => {
  const [pollResultsData, setPollResultsData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    const fetchData = async () => {
      if (currentSlide?.pollId) {
        try {
          const results = await fetchPollCount(currentSlide.pollId);
          setPollResultsData(results);
        } catch (error) {
          console.error("Error fetching poll results:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        console.log("No pollId found for the current slide.");
        setIsLoading(false);
      }
    };

    if (isModalOpen) {
      setIsLoading(true);
      setPollResultsData(null);

      fetchData();
      interval = setInterval(fetchData, 5000); // Call fetchData every 5 seconds
    }

    return () => {
      clearInterval(interval); // Clear the interval when modal is closed or component unmounts
    };
  }, [isModalOpen, currentSlide?.pollId]);

  if (!isModalOpen) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal custom-modal-qna">
        <div className="custom-modal-header">
          {/* <h2>Poll Submissions</h2> */}
        </div>
        <div className="custom-modal-body">
          {isLoading ? (
              <div className="spinner-container">
                  <div className="spinner"></div>
                  <p>Loading results...</p>
              </div>
          ) : pollResultsData ? (
              <div className="answered-count">
                  Participants so far: <strong>{pollResultsData?.totalRespondents}</strong>
              </div>
          ) : (
              <div>No results available.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PollCountPopUP;